import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { LineChart } from 'lucide-react';

const StockTradingPage = () => (
  <ServicePageTemplate
    translationPrefix="stockPage"
    icon={LineChart}
    color="from-indigo-500 to-indigo-600"
    accentColor="bg-indigo-50 border border-indigo-200"
  />
);

export default StockTradingPage;
